export const computePowerConsumptionStatisticsInKWh = (timeseries: { timeStamp: string; value: number; }[]) => {
  let total = 0;
  let max = 0;
  let min: number | null = null;
  let count = 0;
  let averageDeltaMs = 0;

  for (let i = 0; i < timeseries.length; i++) {
    const power = Number(timeseries[i].value) || 0;
    const t1 = new Date(timeseries[i].timeStamp).getTime();
    // If this is last element, set delta to 0 to use averageDeltaMs
    const t2 = timeseries[i + 1] ? new Date(timeseries[i + 1].timeStamp).getTime() : new Date(timeseries[i].timeStamp).getTime();
    let deltaMs = t2 - t1;

    // Section to calculate average delta for last element
    if (deltaMs <= 0 && averageDeltaMs > 0) {
      deltaMs = averageDeltaMs;
    }

    averageDeltaMs = averageDeltaMs ? (averageDeltaMs + deltaMs) / 2 : deltaMs;
    // End of section to calculate average delta for last element

    const wattHours = power * (deltaMs / 3600000); // convert ms to hours

    total += wattHours;
    max = Math.max(max, wattHours);
    min = min === null ? wattHours : Math.min(min, wattHours);
    count++;
  }
  const average = count > 0 ? total / count : 0;

  return {
    average: average / 1000,
    max: max / 1000,
    min: min !== null ? min / 1000 : null,
    total: total / 1000,
  };
};

export const formatEnergyValue = (value: number, unit: string) => {
  const isKWh = unit?.toLowerCase() === 'kwh';

  if (isKWh && value < 1) {
    return {
      unit: 'Wh',
      value: value * 1000,
    };
  }

  return { unit, value };
};
